import React, { useState, useEffect } from 'react'
import MicroModal from 'micromodal'
import Modal from '../components/common/modal/Modal'
import MembersyncTable from './MembersyncTable'
import { useParams } from 'react-router-dom'

import {
    createColumnHelper,
    Table as ReactTable,
} from '@tanstack/react-table'

async function addLicenseMembers(members, licenseExpiresTime, productID, licenseTypeID, orgID) {

    // const url = restUrl + '/wp-json/membersync/licensing/v1/license/add'
    const currentRestUrl = restUrl ?? window.group_dashboard.base
    const url = currentRestUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/license/assign'
    const nonce = restNonce ?? window.group_dashboard.nonce

    let memberAdded = false
    let memberData = []
    let error = ''

    await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            'members': members,
            'org_id': orgID,
            'license_expires_date': licenseExpiresTime,
            'product_id': productID,
            'license_type_id': licenseTypeID
        }),
        headers:{
            'X-WP-Nonce': nonce,
            'Content-type': 'application/json'
        }
    }).then(resp => {
        return resp.json()
    }).then(json => {
        memberAdded = json.success
        memberData = json.response.newMember
        error = json.response.error
    })

    return {
        success: memberAdded,
        data: memberData,
        error: error
    }
}

type AllocatedMembers = {
    username: string
    name: string
    email: string
    expires: string
    subRows?: AllocatedMembers[]
}

const ManageLicense = (props) => {
    MicroModal.init()

    const [licenseMembers, setLicenseMembers] = useState(props.membersAssigned)
    const [errorMessage, setErrorMessage] = useState('')

    const [licenseTotal, setLicenseTotal] = useState(props.total)

    const URLParams = new URLSearchParams(location.search)
    const params = useParams()
    const orgID = URLParams.get('org') ?? params.team_id

    const columnHelper = createColumnHelper<AllocatedMembers>()
    const columns = [
        columnHelper.accessor('username', {
          header: () => <span>Username</span>
        }),
        columnHelper.accessor('name', {
          header: () => <span>Name</span>
        }),
        columnHelper.accessor('email', {
          header: () => <span>Email</span>
        }),
        columnHelper.accessor('expires', {
          header: () => <span>Expires</span>
        })
    ]

    const modalID = "msync-org-manage-license-" + props.productID + "-" + props.licenseTypeID

    const members = {
        "membersync-org-licenses-members" : props.membersAssigned
    }
    
    return (
        <>
            <Modal 
                modalId={modalID} 
                buttonTitle=""
                modalHeading={'Manage License'}
                modalClassNames={'msync-members-custom-modal msync-members-custom-modal-border'}
            >
                <main className="modal__content">
                    <div className="membersync-org-modal-row">
                        <div className="membersync-org-manage-license-name">
                            License Name: {props.name}
                        </div>
                    </div>
                    <div className="membersync-org-modal-row">
                        <div className="membersync-org-manage-license-assigned">
                            Assigned Licenses: {props.assigned} of { tangibleFields.render({
                                type: 'number',
                                name: 'membersync-org-licenses-max',
                                value: licenseTotal
                            }) }
                        </div>
                    </div>
                    <div className="membersync-org-modal-row">
                        <div className="membersync-org-manage-license-members">
                            {
                                <MembersyncTable
                                  {
                                    ...{
                                      data: licenseMembers,
                                      columns,
                                      type: "managePreset"
                                    }
                                  }
                                />
                            }
                            {/* {
                                tangibleFields.render({
                                    type: 'combo-box',
                                    label: '',
                                    name: 'membersync-org-licenses-members',
                                    multiple: true,
                                    isAsync: true,
                                    ajaxAction: 'get_users',
                                    asyncArgs: {
                                        type: 'member',
                                        org: orgID
                                    }
                                })
                            } */}
                            {/* {
                                tangibleFields.render({
                                    type: 'button',
                                    content: 'Allocate to Member',
                                    layout: 'primary',
                                    onClick: async() => {
                                        if ( props.membersAssigned.length + 1 <= licenseTotal ) {
                                            const members = tangibleFields.store.getValue('membersync-org-licenses-members')
                                            const licenseExpiresTime = tangibleFields.store.getValue('membersync-org-license-expires-date')
                                            const result = await addLicenseMembers( members, licenseExpiresTime, props.productID, props.licenseTypeID, orgID )
                                            if ( result.success ) {
                                                // setLicenseMembers([...licenseMembers.concat(result.data)])
                                                // tangibleFields.store.setValue('membersync-org-licenses-members', {})
                                                // setLicenseTotal( licenseMembers.length )
                                            } else {
                                                setErrorMessage(result.error.message)
                                            }
                                        }
                                    },
                                    name: 'membersync-org-allocate-member'
                                }, 'element')
                            }
                            {
                                tangibleFields.render({
                                    name: 'membersync-org-license-expires-date',
                                    type: 'date-picker',
                                    futureOnly: true,
                                })
                            } */}
                        </div>
                    </div>
                    <div className="membersync-org-modal-row">
                        <div className="membersync-org-manage-license-contents">
                            <div className="membersync-org-manage-license-contents-header">
                                <div>
                                    Content name
                                </div>
                                <div>
                                    Content type
                                </div>
                            </div>
                            {
                                (props.content).map( access => (
                                    <div className="membersync-org-manage-license-contents-row">
                                        <div>
                                            {/* { access.title } */}
                                            { access }
                                        </div>
                                        <div>
                                            {/* { access.content } */}
                                            Course
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <footer className="msync-modal__footer">
                        <button className="msync-button msync-button--is-style-outline msync-button--is-theme-destructive" type="button" onClick={() => MicroModal.close(modalID)} >Cancel</button>
                        <button className="msync-button" type="button" onClick={() => {
                            props.afterEdit()
                            MicroModal.close(modalID)
                        }} >Save</button>
                    </footer>
                </main>
            </Modal>
        </>
    );
};

export default ManageLicense;